import { useTranslation } from 'react-i18next';
import { Popover, VStack } from 'native-base';

import { Button, HelpCircleIcon, Text } from '@pimm/base';

export const PopoverTooltipStoreReports = () => {
  const { t } = useTranslation();

  return (
    <Popover
      placement="left"
      isKeyboardDismissable
      _backdrop={{ bg: 'black' }}
      trigger={triggerProps => (
        <Button variant="unstyled" w={9} h={8} alignItems="center" borderColor="gray.300" bg="white" shadow={0} {...triggerProps}>
          <HelpCircleIcon size="20px" color="gray.700" />
        </Button>
      )}
    >
      <Popover.Content accessibilityLabel="End of day review" shadow={4} mr={3} rounded="lg" top={20} borderWidth={0} bg="white">
        <Popover.Arrow borderWidth={0} borderColor="white" bg="white" />
        <Popover.Body p={3} w={418} justifyContent="center" bg="white">
          <VStack flex={1} space={1} alignContent="center">
            <Text size="md" fontWeight={600} color="gray.900" lineHeight="sm">
              {t('store_inspections:eod_end_of_day_review')}
            </Text>
            <Text size="md" fontWeight={500} color="gray.700" lineHeight="sm">
              {t('store_inspections:eod_end_of_day_review_description')}
            </Text>
            <Text size="md" fontWeight={500} color="gray.700" lineHeight="sm" mt={2}>
              {`${t('store_inspections:user_permission_role')} ${t('store_inspections:sms_manager')}`}
            </Text>

            <Text size="md" fontWeight={600} color="gray.900" lineHeight="sm" mt={3}>
              {t('store_inspections:weekly_review')}
            </Text>
            <Text size="md" fontWeight={500} color="gray.700" lineHeight="sm">
              {t('store_inspections:weekly_review_description')}
            </Text>
            <Text size="md" fontWeight={500} color="gray.700" lineHeight="sm" mt={2}>
              {`${t('store_inspections:user_permission_role')} ${t('store_inspections:corp_manager')}`}
            </Text>
          </VStack>
        </Popover.Body>
      </Popover.Content>
    </Popover>
  );
};
